import React from "react";
import styles from "../../../../../css/index.css";
import { SocialIcon } from "../../graphicElements/index.js";
const SocialSection = () => /*#__PURE__*/React.createElement("div", {
  role: "group",
  "aria-roledescription": "navigation level 2",
  "aria-label": "social media"
}, /*#__PURE__*/React.createElement("ul", {
  role: "list",
  className: styles.socialIconsSection
}, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(SocialIcon, {
  name: "facebook"
})), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(SocialIcon, {
  name: "twitter"
})), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(SocialIcon, {
  name: "pinterest"
})), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(SocialIcon, {
  name: "instagram"
}))));
export default SocialSection;